var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.246 5.31618C2.58497 4.92316 2.98348 4.58573 3.427 4.31618L9.427 0.716181C10.2036 0.24856 11.093 0.00146484 11.9995 0.00146484C12.906 0.00146484 13.7954 0.24856 14.572 0.716181L20.572 4.31618C21.016 4.58545 21.4149 4.92291 21.754 5.31618L12 11.1692L2.246 5.31618ZM13 12.9002V23.8892C13.5542 23.7798 14.0858 23.5769 14.572 23.2892L20.572 19.6892C21.3109 19.2429 21.9224 18.6139 22.3477 17.8626C22.7729 17.1114 22.9976 16.2634 23 15.4002V8.60018C22.9964 8.07509 22.9094 7.55391 22.742 7.05618L13 12.9002ZM11 12.9002L1.258 7.05618C1.09065 7.55391 1.00356 8.07509 1 8.60018V15.4002C1.00248 16.2631 1.22706 17.1109 1.65212 17.8619C2.07719 18.6129 2.68843 19.2419 3.427 19.6882L9.427 23.2882C9.91353 23.5759 10.4454 23.7788 11 23.8882V12.9002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectBtn);
export default __webpack_public_path__ + "static/media/project-btn.f13855d0.svg";
export { ForwardRef as ReactComponent };